/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Please_Enter_A_Valid_Domain_EInputs */

const en_please_enter_a_valid_domain_e = /** @type {(inputs: Please_Enter_A_Valid_Domain_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid domain (e.g. yourbrand.com)`)
};

const es_please_enter_a_valid_domain_e = /** @type {(inputs: Please_Enter_A_Valid_Domain_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, introduce un dominio válido (ej. tumarca.com)`)
};

const fr_please_enter_a_valid_domain_e = /** @type {(inputs: Please_Enter_A_Valid_Domain_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez entrer un domaine valide (ex. votremarque.com)`)
};

const de_please_enter_a_valid_domain_e = /** @type {(inputs: Please_Enter_A_Valid_Domain_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte gib eine gültige Domain ein (z.B. deinemarke.com)`)
};

const ja_please_enter_a_valid_domain_e = /** @type {(inputs: Please_Enter_A_Valid_Domain_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効なドメインを入力してください (例: yourbrand.com)`)
};

const zh_please_enter_a_valid_domain_e = /** @type {(inputs: Please_Enter_A_Valid_Domain_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入有效的域名 (例如 yourbrand.com)`)
};

const ar_please_enter_a_valid_domain_e = /** @type {(inputs: Please_Enter_A_Valid_Domain_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الرجاء إدخال نطاق صالح (مثال: yourbrand.com)`)
};

const id_please_enter_a_valid_domain_e = /** @type {(inputs: Please_Enter_A_Valid_Domain_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harap masukkan domain yang valid (mis. merekanda.com)`)
};

const it_please_enter_a_valid_domain_e = /** @type {(inputs: Please_Enter_A_Valid_Domain_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per favore, inserisci un dominio valido (es. iltuobrand.com)`)
};

const ru_please_enter_a_valid_domain_e = /** @type {(inputs: Please_Enter_A_Valid_Domain_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, введите действительный домен (например, yourbrand.com)`)
};

const pt_please_enter_a_valid_domain_e = /** @type {(inputs: Please_Enter_A_Valid_Domain_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, insira um domínio válido (ex. suamarca.com)`)
};

const ko_please_enter_a_valid_domain_e = /** @type {(inputs: Please_Enter_A_Valid_Domain_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`올바른 도메인을 입력해 주세요 (예: yourbrand.com)`)
};

/**
* | output |
* | --- |
* | "Please enter a valid domain (e.g. yourbrand.com)" |
*
* @param {Please_Enter_A_Valid_Domain_EInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const please_enter_a_valid_domain_e = /** @type {((inputs?: Please_Enter_A_Valid_Domain_EInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Please_Enter_A_Valid_Domain_EInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_please_enter_a_valid_domain_e(inputs)
	if (locale === "es") return es_please_enter_a_valid_domain_e(inputs)
	if (locale === "fr") return fr_please_enter_a_valid_domain_e(inputs)
	if (locale === "de") return de_please_enter_a_valid_domain_e(inputs)
	if (locale === "ja") return ja_please_enter_a_valid_domain_e(inputs)
	if (locale === "zh") return zh_please_enter_a_valid_domain_e(inputs)
	if (locale === "ar") return ar_please_enter_a_valid_domain_e(inputs)
	if (locale === "id") return id_please_enter_a_valid_domain_e(inputs)
	if (locale === "it") return it_please_enter_a_valid_domain_e(inputs)
	if (locale === "ru") return ru_please_enter_a_valid_domain_e(inputs)
	if (locale === "pt") return pt_please_enter_a_valid_domain_e(inputs)
	return ko_please_enter_a_valid_domain_e(inputs)
});